<template>
  <div>
    <b-card>
      <b-card-body>
        <b-media class="mb-3">
          <template #aside>
            <img src="@/assets/img/icon_jobfair_1.png" alt="MUIC" />
          </template>
          <h4 class="font-en mt-4">Student Activities</h4>
        </b-media>
        <h5 class="mt-3 mb-0 font-weight-bold">Club ( {{ dataClub.length }} )</h5>
        <!-- table - club -->
        <b-table
          class="mt-3"
          striped
          hover
          :items="dataClub"
          :fields="fieldsClub"
          :busy="tableLoading"
          responsive="sm"
          show-empty
        >
          <template v-slot:table-busy>
            <div class="text-center my-2">
              <b-spinner class="align-middle"></b-spinner>
              Loading...
            </div>
          </template>
        </b-table>
        <!-- table - activity -->
        <h5 class="mt-0 mb-0 font-weight-bold">Activity ( {{ dataActivity.length }} )</h5>
        <b-table
          class="mt-3"
          striped
          hover
          :items="dataActivity"
          :fields="fields"
          :busy="tableLoading"
          responsive="sm"
          show-empty
        >
          <template v-slot:table-busy>
            <div class="text-center my-2">
              <b-spinner class="align-middle"></b-spinner>
              Loading...
            </div>
          </template>
          <!-- <template v-slot:cell(check_date)="row"></template> -->
        </b-table>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dataClub: [],
      dataActivity: [],
      tableLoading: false,
      fieldsClub: [
        {
          sortable: true,
          key: "budget_detail.plan_detail.term",
          label: "Term",
          class: "text-center",
        },
        {
          sortable: true,
          key: "budget_detail.plan_detail.academic_year",
          label: "Year",
          class: "text-center",
        },
        {
          sortable: true,
          key: "club_name",
          label: "Name [En]",
          class: "",
        },
        {
          sortable: true,
          key: "position",
          label: "Position",
          class: "",
        },
      ],
      fields: [
        {
          sortable: true,
          key: "activity_detail.activity_term",
          label: "Term",
          class: "text-center",
        },
        {
          sortable: true,
          key: "activity_detail.activity_year",
          label: "Year",
          class: "text-center",
        },
        {
          sortable: true,
          key: "activity_detail.activity_name_eng",
          label: "Name [En]",
          class: "",
        },
        {
          sortable: true,
          key: "position",
          label: "Position",
          class: "",
        },
      ],
    };
  },
  mounted() {
    this.tableLoading = true;
    this.getListEventClub();
    this.getListEventActivity();
    this.tableLoading = false;
  },
  methods: {
    async getListEventClub() {
      this.dataClub = [];
      try {
        const res = await this.$http.get(`/student-activities/club/me/`);
        if (res.status === 200) {
          this.dataClub = res.data;
          if(this.dataClub.length !== 0){
            this.dataClub.sort((a, b) => {
              return b.budget_detail.plan_detail.academic_year - a.budget_detail.plan_detail.academic_year;
            });
          }
        } else {
          throw { res };
        }
      } catch (error) {
        this.dataClub = [];
      }
    },
    async getListEventActivity() {
      this.dataActivity = [];
      try {
        const res = await this.$http.get(`/student-activities/member/me/`);
        if (res.status === 200) {
          this.dataActivity = res.data;
          // sort
          if(this.dataActivity.length !== 0){
            this.dataActivity.sort((a, b) => {
              return b.activity_detail.activity_year - a.activity_detail.activity_year;
            });
          }
        } else {
          throw { res };
        }
      } catch (error) {
        this.dataActivity = [];
      }
    },
  },
};
</script>